import { Passenger, PassengerFormModel } from "./passenger.model";
import { ProductTypeUrl } from "app/shared/models/enums/ProductTypeUrl.enum";
import { Availability } from "app/shared/models/availability.model";
import {
    PassengerRequest,
    GetTravelOptions,
    PassOptions
} from "app/shared/services/booking.service";
import { GxConstants } from 'app/shared/constants/gx.constants';

export class Booking {
    BookingGuid: string;
    BookingNumber: string;
    ProductType: string;
    FareBasis: Array<Farebasis>;
    FareTypes: Array<FareType>;
    PassDaysRemaining: number;
    Pin: number;
    BookingDate: Date;
    Tours: Array<any>;
    PassKms: string;
    PassKmsUsed: string;
    Pass: Pass;
    Package: Package;
    PassExpiry: Date;
    TicketUrl: string;
    Sectors: Array<Sector>;
    HasReturnTravel: boolean;
    CustomerGuid: string;
    SendConfirmation: boolean;
    // Added to booking
    IS_TICKETED: boolean;
    ShowAddTravelBtn: boolean;
    TransactionNumber: string;
    TpProducts: Array<TpProduct>;
    NursingInfants: number;

    Passengers: Array<Passenger>;
    // Added to booking to pay using kms
    balanceBeforePayment: number;
    balanceAfterPayment: number;
    kmsPassName: string;
    visible: boolean;
    // addTravelToBooking
    travels: Availability[];
    addons: Array<Addon>;
    cartTotal: Totals;
    pass: Pass;
    passengerDetails: PassengerFormModel; // TODO check Passenger;
    promocode: string;
    promocodeDescription: string;
    requiresVisa: boolean;
    visaNumber: string;
    visaPromoCode: string;
    ShowExtendPassBtn: boolean;
    FullPackageCartTotal: number;
    PromotionDescription: string;

    public static getMainObject(
        parentBooking: Booking,
        productType: ProductTypeUrl,
        firstElementIfArray: boolean
    ): any | any[] | Pass | Package | null | TourOrExperience {
        let obj = null;
        if (!!parentBooking && !!parentBooking.Tours) {
            switch (productType) {
                case ProductTypeUrl.accommodation:
                case ProductTypeUrl.experience:
                    if (firstElementIfArray) {
                        obj = parentBooking.Tours[0];
                    } else {
                        obj = parentBooking.Tours;
                    }
                    break;
                case ProductTypeUrl.travelPasses:
                    obj = parentBooking.Pass;
                    break;
                case ProductTypeUrl.package:
                    obj = parentBooking.Package;
                    break;
                case ProductTypeUrl.manageBooking:
                    obj = parentBooking.Pass;
                    break;
                default:
            }
        }
        return obj;
    }

    public static getPassengerCountWithExclusions(b: Booking): number {
        let totalPax = this.getPassengerCount(b);
        GxConstants.EXPRESS_ADDONS_FAREBASIS_EXCLUSIONS.forEach(ex => {
            b.FareBasis.forEach(fb => {
                if(fb.FarebasisCode.toUpperCase().trim() == ex.toUpperCase().trim()){
                    totalPax --;
                }
            })
        })
        return totalPax;
    }

    public static getPassengerCount(b: Booking): number {
        let totalPax = 0;
        b.Passengers.forEach(p => {
            totalPax += p.MaleCount;
            totalPax += p.FemaleCount;
        });
        return totalPax;
    }
}
export class OptionValueEntityInstance {
    Selected: boolean;
    SalePriceUnit: number;
    ProductCode: string;
    IsReturn: boolean;
    UsageDate: string;
    OnlineDescription: string;
    OnlineDescriptionAlternate: string;
    SoldDescription: string;
    MatchingProductCodes: string;
}
export class AddonOption {
    Selected: boolean;
    OptionValueEntity: Array<OptionValueEntityInstance>;
    FieldType: string;
    UserSelection;
    ProductCode: string;
    SalePriceUnit: string;
    UsageDate: string;
    Quantity: number;
    CanPurchase: boolean;
    Show: boolean;
}
export class GetAddonsOptions {
    FuelSurcharge: number;
    IsReturn: boolean;

    constructor(
        private ProductRef: string,
        private FarePrice: number,
        private PassengerQty: number
    ) {}
}
export class FlattenedAddon {
    productCode: string;
    salePriceUnit: number;
    Type: string;
    quantity: number;
    usageDate: string;

    public constructor(productCode, salePriceUnit) {
        this.productCode = productCode;
        this.salePriceUnit = salePriceUnit;
    }
}
export class FareTypeOption {
    constructor(
        public Amount: number,
        public AddonType: string,
        public FareTypeCode: string,
        public UsageDate: string
    ) {}
}
export class CreateBookingOptions {
    Passenger: PassengerRequest;
    Travels: Array<GetTravelOptions>;
    InsuranceAmount: number;
    ProcessingFeeAmount: number;
    ThirdPartyAddons: Array<FareTypeOption>;
    Addons: Array<FareTypeOption>;
    SelectedLoyaltyProgram: number;
    CustomerWishsToUseFreeTrip: boolean;
    CustomerGuid: string;
    Pass: PassOptions;
    BookingGuid: string;
}
export class Addon {
    IconUrl: string;
    Title: string;
    Description: string;
    Notes: string;
    Collapsed: boolean;
    // TODO Which on is right?
    Type: string;
    AddonType: string;

    productCode: string;

    salePriceUnit: number;

    AddonOptions: Array<AddonOption>;
    AddonEntityGuid: string;
    SectorAddon: boolean;
    //        constructor(private max: number, private males = 0, private females = 0) {
    //
    //        }
}
export class Item {
    Amount: number;
    Quantity: number;
    Name: string;
    ProductCode: string;
    PromoCode: string;
    PromoDescription: string;
}
export class PaymentItem {
    Sku: string;
    Items: Array<Item>;
    Message: string;
    Total: number;
    Description: string;
}
export class Totals {
    TotalCost: number;
    CreditsEarned: number;
    RedemptionPortion: number;
    PaymentItems: Array<PaymentItem>;
}

export class Location {
    Code: string;
    Coordinates: string;
    Description: string;
    Image1: string;
    Image1AltText: string;
    Image2: string;
    Image2AltText: string;
    Index: number;
    LocationText: string;
    Priority: number;
    RegionDescription: string;
    Status: boolean;
    UrlReference: string;

    public toString() {
        return this.Code;
    }
}

export class Sector {
    SectorNumber: number;
    ServiceNumber: number;
    OriginStopCode: string;
    DestinationStopCode: string;
    PassengerBoardingDate: string;
    // mutable
    timetable: any;
    timetableDisplayed: boolean;
    displayChangeDate: boolean;
    departureDate: string;
    SpecialType: string;
    SectorGuid: string;
    OpenDatedUntil: string;
    IsWifiEnabledService: boolean;
    ShowChangeSectorBtn: boolean;
    ShowDeleteSectorBtn: boolean;
    OriginName: string;
    OriginLatitude: string;
    OriginLongitude: string;
    DestinationName: string;
    DestinationLatitude: string;
    DestinationLongitude: string;
    PassengerArrivalDate: string;
    TotalDurationText: string;
    ServiceCompany: string;
    FareType: string;
    IsFirstOriginatingSector: boolean;
    IsFirstReturnSector: boolean;
    Addons: Array<Addon>;

    hasAddon(ovei: OptionValueEntityInstance): boolean {
        let addonExists = false;
        this.Addons.forEach(a => {
            a.AddonOptions.forEach(o => {
                o.OptionValueEntity.forEach(ov => {
                    if(ovei.ProductCode === ov.ProductCode){
                        addonExists = true;
                    }
                })
            })
        })
        return addonExists;
    }
}

export class TpProduct {
    Name: string;
    SalePrice: number;
    ProductCode: string;
    TourGuid: string;
    QuantityToBook: number;
    UsageDate: string;
    TicketNumber: string;
}

abstract class Product {
    FareTypes: Array<FareType>;
    SelectedFareType: string;
    PromotionCode: string;
    PromotionDescription: string;
    LinkedToSector: boolean;
}

export class TourOrExperience extends Product {
    Name: string;
    DisplayDescription: string;
    TourGuid: string;
    TourReference: string;
    SelectedDate: string;
    SelectedCurrency: string;
    SelectedCurrencyAmount: number;
    PurchaseNumber: string;
    ProductStatus: number;
    Image2: string;
    Description: string;
    Quantity: number;
}

export class Package extends Product {
    Locations: Array<Location>;
    Inclusions: Array<Inclusion>;
    PackageGuid: string;
    RequiresTravel: boolean;
    OneWayTravel: boolean;
    PrimaryLocationCode: string;
    SuggestedDepDate: string;
    SuggestedRetDate: string;
    DestinationLocationCode: string;
    DestinationLocationName: string;
    ShowTravel: boolean;
    UniqueId: string;
    PackageReference: string;
    LimitedStops: boolean;
    Name: string;
    Image2: string;
    Description: string;
}
export class Pass extends Product {
    PassReference: string;
    PassGuid: string;
    Name: string;
    CategoryReference: string;
}
export class Inclusion {
    Name: string;
    SelectedDate: string;
    SortOrder: number;
    TourGuid: string;
    ShowUsageDate: boolean;
    FareTypes: Array<FareType>;
    ProductStatus: number;
    PurchaseNumber: string;
    ProductCode: string;
    // added
    invisible: boolean;
    tourGuids: string[];
}

export class FareType {
    Farebasis: Farebasis;
    FareTypeCode: string;
    Description: string;
    BookDaysPriorTo: number;
    OperatingDays: Array<string>;
    RequiresUsageDate: boolean;
    ShowUsageDate: boolean;
    SalePrice: number;
    SalePriceKM: number;
    TotalPrice: number;
    OnlineName: string;
    InternetDescription: string;
    DisplayDescription: string;

    get descriptionToDisplay(): string {
        return this.OnlineName;
    }
}

export class Farebasis {
    FarebasisCode: string;
    DisplayDescription: string;
    SalePrice: number;
    TotalPrice: number;
    ReportingGroup: string;
    NumberToBook: number;
    InternetDescription: string;
    RequiresVisa: boolean;
    PromotionDescription: string;
}

export class BookingManagementHeaders {
    BookingDetailsExpanded: boolean;
    PassengerDetailsExpanded: boolean;
    ItineraryExpanded: boolean;

    constructor() {
        this.BookingDetailsExpanded = false;
        this.PassengerDetailsExpanded = false;
        this.ItineraryExpanded = false;
    }
}
export class AddonEntity {
    Description: string;
    OnlineDescription: string;
    ProductCode: string;
    PromoCode: string;
    SalePriceUnit: number;
    Selected: boolean;
    UsageDate: string;
    Used: boolean;
}
export class AddonResponse {
    type: string;
    entities: Array<AddonEntity>;
    description: string;
}

export class ServiceUpdate {
    constructor(
        public ReasonDescription?: string,
        public PublishDate?: string,
        public Update?: string
    ) {}
}

export class TravelCentre {
    ID: string;
    TerminalName: string;
    Address1: string;
    Address2: string;
    Latitude: string;
    Longitude: string;
    Phone1: string;
    OpenMon: string;
    OpenTue: string;
    OpenWed: string;
    OpenThu: string;
    OpenFri: string;
    OpenSat: string;
    OpenSun: string;
}

export class ContextDataResolve {
    contextData: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/booking.model.ts